/* @flow */

import React from 'react';
import Relay from 'react-relay';

import { connect } from 'react-redux';

import { compose } from 'recompose';

import Container from 'depop/components/layout/Container';
import NotificationsList from 'depop/components/NotificationsList';

import provideIdGenerator from 'depop/UniqueIdProvider';

import { css } from 'glamor';
import applyRootStyles from 'depop/utils/applyRootStyles';
import { ZINDEX_PAGE_BOTTOM_WRAP } from 'depop/styles/zIndex';
import { currentUserFragment } from 'depop/getCurrentUser';

import OverlayBackground from './navigation/OverlayBackground';

import SearchOverlay from './navigation/SearchOverlay';
import MobileMenu from 'depop/components/layout/navigation/MobileMenu';

import AppNavigation from 'depop/root/containers/components/AppNavigation';
import DeeplinkBanner from 'depop/components/banners/DeeplinkBanner';

import CookieBanner from 'depop/components/banners/CookieBanner';

applyRootStyles();

class Shell extends React.PureComponent {
  props: {
    children: Object,
    hideHeader: boolean,
    hideFooter: boolean,
    hideAppBanner: boolean,
    hideCookieBanner: boolean,
    viewer: Object,
  };

  render() {
    const {
      children,
      viewer,
      hideHeader,
      hideFooter,
      hideAppBanner,
      hideCookieBanner,
      navigation: { isSearchOpen, isMobileNavOpen },
    } = this.props;

    const bottomPlacementStyle = {
      position: 'fixed',
      bottom: '0px',
      left: '0px',
      right: '0px',
      zIndex: ZINDEX_PAGE_BOTTOM_WRAP
    };

    return (
      <div {...css({ position: 'relative' })}>
        <AppNavigation viewer={viewer} hideHeader={hideHeader} hideFooter={hideFooter} />
        <div {...css({ marginBottom: 54 })}>
          <Container>{children}</Container>
        </div>
        <div {...css(bottomPlacementStyle)} >
          {hideAppBanner ? null : <DeeplinkBanner />}
          {hideCookieBanner ? null : <CookieBanner />}
        </div>
        <NotificationsList />
        <OverlayBackground />
        <MobileMenu user={viewer.currentUser} isOpen={isMobileNavOpen} />
        <SearchOverlay isOpen={isSearchOpen} />
      </div>
    );
  }
}

const mapStateToProps = ({ navigation }) => ({
  navigation,
});

const connector = connect(mapStateToProps);

const enhance = compose(connector, provideIdGenerator);

export default Relay.createContainer(enhance(Shell), {
  fragments: {
    viewer: () => Relay.QL`
      fragment on Viewer {
        currentUser {
          ${MobileMenu.getFragment('user')}
        }
        ${currentUserFragment}
        ${AppNavigation.getFragment('viewer')}
        ${AppNavigation.getFragment('viewer')}
      }
    `,
  },
});



// WEBPACK FOOTER //
// ../src/client/components/layout/Shell.js